/* eslint-disable*/
import React, { useContext } from 'react';
import { Context } from 'context/AuthContext';

import Drawer from 'components/Drawer';
import Brand from 'components/_base/Brand';
import LoggedUser from 'components/LoggedUser';
import Notifications from 'components/Notifications';
import NotificacaoChamados from 'components/NotificacaoChamados';

import './styles.scss';

const HeaderApp = () => {
  const { userData } = useContext(Context);

  return (
    <header className="header-app">
      <Drawer />
      <div
        className="brand-app"
        style={{ justifyContent: 'start', alignItems: 'center' }}
      >
        <div>
          <a href="/">
            <Brand />
          </a>
        </div>
      </div>
      <LoggedUser />
      <NotificacaoChamados />
      {userData.siglaTipo !== 'COOR' &&
        <Notifications />
      }
    </header>
  );
};

export default HeaderApp;
